export default __webpack_public_path__ + "static/media/tsa-painting-banner.66123129.jpg";